export interface AreaSection {
  heading: string;
  paragraphs: string[];
}

export interface AreaData {
  slug: string;
  name: string;
  heroTitle: string;
  hook?: string;
  image?: string;
  sections: AreaSection[];
  closingCta: string;
  citySpecificFact?: string;
  seoDescription?: string;
  isProductOnly?: boolean;
  showroomUrl?: string;
  type?: "city" | "county" | "product";
  cities?: string[];
}

export const areas: AreaData[] = [
  {
    slug: "fort-lauderdale",
    name: "Fort Lauderdale",
    heroTitle:
      "Transform Your Fort Lauderdale Outdoor Space with Precision Pavers & Pool Design",
    hook: "Pool remodeling, pavers, and outdoor enhancements in Fort Lauderdale",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/7cd2049e-4cd0-4d90-8db3-3c54e38a7f56.webp",
    citySpecificFact:
      "Serving Fort Lauderdale neighborhoods including Victoria Park, Coral Ridge, Las Olas Isles, Harbor Beach, Rio Vista, Sailboat Bend, and Wilton Manors. We are familiar with Fort Lauderdale's city permitting process and HOA architectural review requirements.",
    sections: [
      {
        heading: "Welcome to Fort Lauderdale",
        paragraphs: [
          "Welcome to Fort Lauderdale, a city that perfectly balances the charm of a coastal paradise with the energy of a bustling metropolis. As the Venice of America, Fort Lauderdale is renowned for its intricate network of waterways, stunning beaches, and vibrant cultural scene. At Precision Pavers & Pool Design, we're not just here to enhance your outdoor space – we're here to harmonize it with the city's dynamic spirit.",
        ],
      },
      {
        heading: "A City of Beaches and Beyond",
        paragraphs: [
          "Fort Lauderdale's allure lies in its diverse landscape. From the pristine sandy shores of Fort Lauderdale Beach to the historic charm of Las Olas Boulevard, the city offers a variety of experiences for both residents and visitors. The Intracoastal Waterway, with its iconic yachts and water taxis, is a testament to the city's unique waterfront culture.",
        ],
      },
      {
        heading: "Tailored Paver Solutions for Fort Lauderdale",
        paragraphs: [
          "At Precision Pavers & Pool Design, we understand that Fort Lauderdale's outdoor spaces deserve paver solutions that reflect the city's distinct character. Our range of services, from pool remodeling to deck resurfacing to driveway paving, is designed to seamlessly integrate with the area's local aesthetic. Did you know? Precision Pavers and Pool Design is your go-to choice for Fort Lauderdale swimming pool remodeling, offering top-notch expertise and a commitment to turning your pool dreams into reality.",
        ],
      },
      {
        heading: "Elevate Your Pool Area",
        paragraphs: [
          "Our swimming pool remodeling services are tailored to Fort Lauderdale's love for outdoor living. Create an oasis of comfort and relaxation with our high-quality paver designs that complement the city's tropical ambiance.",
        ],
      },
      {
        heading: "Craft Your Dream Deck",
        paragraphs: [
          "When it comes to deck remodeling and resurfacing, we ensure your outdoor space captures the essence of Fort Lauderdale's coastal beauty. Whether you're looking for a chic modern design or a classic retreat, our experts will transform your pool deck into a stunning extension of your home.",
        ],
      },
      {
        heading: "Local Expertise Matters",
        paragraphs: [
          "As a local business with over two decades of experience, we've had the privilege of witnessing Fort Lauderdale's evolution firsthand. We know the city's architecture, climate, and lifestyle inside out, enabling us to create outdoor spaces that resonate with residents' preferences.",
        ],
      },
      {
        heading: "Your Fort Lauderdale Haven",
        paragraphs: [
          "Imagine basking in the Florida sun on a pool deck that mirrors the city's sun-soaked charm, or entertaining guests amidst a backdrop that captures Fort Lauderdale's vibrant energy. Precision Pavers & Pool Design brings your outdoor dreams to life while preserving the essence of this remarkable city.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "coral-springs",
    name: "Coral Springs",
    heroTitle:
      "Upgrade Your Coral Springs Spaces with Precision Pavers & Pool Design",
    hook: "Premium pool and paver services in Coral Springs",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/cedd58f5-d219-44f4-b0b5-d857a8676cbb.webp",
    citySpecificFact:
      "Serving Coral Springs communities including Heron Bay, Forest Hills, Wyndham Lakes, Turtle Run, Eagle Trace, and The Lakes of Coral Springs. We work with Coral Springs building department and local HOA guidelines.",
    sections: [
      {
        heading: "Embracing Natural Beauty",
        paragraphs: [
          "Coral Springs takes pride in its natural beauty. Here, you'll find meticulously maintained parks, serene waterways, and vibrant green spaces. The city's commitment to preserving its natural charm is evident in every corner, making it a haven for outdoor enthusiasts and families alike.",
        ],
      },
      {
        heading: "A Place for Families",
        paragraphs: [
          "Coral Springs stands as a testament to the ideals of family, unity, and safety. With top-rated schools, friendly neighborhoods, and a warm sense of community, it's no wonder why families flock to this city. From local events to diverse cultural experiences, Coral Springs offers something for everyone.",
        ],
      },
      {
        heading:
          "Precision Pavers & Pool Design: Transforming Coral Springs' Outdoor Spaces",
        paragraphs: [
          "At Precision Pavers & Pool Design, we understand the unique allure of Coral Springs. Our mission is to enhance the city's outdoor spaces, ensuring they harmonize seamlessly with the area's natural beauty and family-centric ethos. That's why residents of Coral Springs choose our residential and commercial paving services!",
        ],
      },
      {
        heading: "Turning Dreams into Reality",
        paragraphs: [
          "In Coral Springs, the backyard isn't just an extension of your home; it's a canvas for your dreams. Whether you envision a serene pool area, an inviting deck, or an elegant driveway, Precision Pavers is here to make your vision a reality. Our team boasts years of experience and a passion for creating outdoor havens.",
        ],
      },
      {
        heading: "Choose Precision Pavers & Pool Design",
        paragraphs: [
          "Elevate your Coral Springs living experience with Precision Pavers & Pool Design. With unwavering dedication and an eye for detail, we're committed to enhancing your outdoor oasis. Contact us today for a personalized consultation, and let's embark on the journey of transforming your outdoor space.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "pembroke-pines",
    name: "Pembroke Pines",
    heroTitle:
      "Redesign Your Pembroke Pines Spaces with Precision Pavers & Pool Design",
    hook: "Expert outdoor transformations in Pembroke Pines",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/8539b272-8a82-451a-b764-dd21a3898c7d.jpg",
    citySpecificFact:
      "Serving Pembroke Pines including Century Village, Pembroke Lakes, Silver Lakes, Chapel Trail, Grand Palms, and Walden Chase. Familiar with Pembroke Pines city permitting and Miami-Dade/Broward county line regulations.",
    sections: [
      {
        heading: "Discover the Beauty of Pembroke Pines, Florida",
        paragraphs: [
          "Nestled in the heart of sunny South Florida, Pembroke Pines is a hidden gem that's just waiting to be explored. This vibrant city boasts a unique blend of modern conveniences and natural beauty, making it an ideal place to call home. From its lush parks to its family-friendly atmosphere, Pembroke Pines offers something for everyone.",
        ],
      },
      {
        heading: "Pembroke Pines: A City of Parks and Recreation",
        paragraphs: [
          "One of the standout features of Pembroke Pines is its commitment to green spaces and recreation. The city is dotted with beautifully maintained parks, offering residents and visitors ample opportunities to enjoy the outdoors. C.B. Smith Park, for instance, is a sprawling oasis featuring a water park, golf course, and picnic areas. It's the perfect spot for a family outing or a relaxing day in the sun.",
        ],
      },
      {
        heading: "Vibrant Communities, Diverse Cultures",
        paragraphs: [
          "Pembroke Pines is known for its diverse and welcoming community. People from all walks of life come together to create a rich cultural tapestry. This diversity is reflected in the city's events, restaurants, and local businesses. Whether you're craving authentic Cuban cuisine or exploring local art galleries, Pembroke Pines has something to satisfy your senses.",
        ],
      },
      {
        heading: "Enhancing Pembroke Pines, One Paver at a Time",
        paragraphs: [
          "At Precision Pavers & Pool Design, we're proud to serve the residents of Pembroke Pines. We understand the unique needs of this community and are dedicated to enhancing outdoor spaces, one paver at a time. Our services go beyond the ordinary. We offer customized solutions for Pembroke Pines pool remodeling, deck resurfacing, and driveway paving that blend seamlessly with the city's character.",
        ],
      },
      {
        heading: "Your Dream Outdoor Space Awaits",
        paragraphs: [
          "In Pembroke Pines, residents take pride in their homes and outdoor spaces. Our team at Precision Pavers is committed to helping you transform your vision into reality. Whether it's rejuvenating your pool area, upgrading your deck, or enhancing your driveway, we have the expertise to create the perfect outdoor oasis for your Pembroke Pines home.",
        ],
      },
      {
        heading: "Choose Precision Pavers & Pool Design",
        paragraphs: [
          "When it comes to elevating your outdoor living experience in Pembroke Pines, Precision Pavers & Pool Design is your trusted partner. With years of experience and a passion for craftsmanship, we're dedicated to exceeding your expectations. Contact us today for a personalized consultation and let's bring your outdoor dreams to life.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "weston",
    name: "Weston",
    heroTitle:
      "Recreate Your Weston, FL Outdoor Spaces with Precision Pavers & Pool Design",
    hook: "Luxury pool and paver solutions in Weston",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/1aaa5a4e-9c69-43cc-91c2-60ab1ff1098e.jpg",
    citySpecificFact:
      "Serving Weston neighborhoods including Weston Hills, The Country Club at Weston, Bonaventure, Windmill Ranch, Saddle Club, and Ridge at Weston. Experienced with Weston's HOA and ARB approval processes.",
    sections: [
      {
        heading: "Discover the Tranquil Beauty of Weston, Florida",
        paragraphs: [
          "Located in the heart of Broward County, Weston, Florida, is a city that effortlessly blends modern living with the serenity of natural landscapes. Known for its lush green spaces, family-friendly atmosphere, and a commitment to a high quality of life, Weston welcomes residents and visitors with open arms.",
        ],
      },
      {
        heading: "Embracing Nature in Weston",
        paragraphs: [
          "One of Weston's most cherished attributes is its dedication to preserving nature's beauty. The city is adorned with meticulously maintained parks, offering a peaceful escape from the hustle and bustle. Places like Weston Regional Park and Peace Mound Park provide serene settings for picnics, leisurely strolls, and a deeper connection with nature.",
        ],
      },
      {
        heading: "A Family-Oriented Community",
        paragraphs: [
          "Weston prides itself on being a close-knit and family-oriented community. Residents here enjoy top-rated schools, safe neighborhoods, and a strong sense of belonging. The city's commitment to fostering a welcoming environment is evident in its many family-centered events and activities.",
        ],
      },
      {
        heading:
          "Precision Pavers & Pool Design: Enhancing Weston's Outdoor Spaces",
        paragraphs: [
          "At Precision Pavers & Pool Design, we're honored to be a part of the Weston community. We understand the unique charm and outdoor lifestyle that Weston offers to its residents. That's why we're dedicated to providing top-notch services in Weston pool remodeling, deck resurfacing, and driveway paving that seamlessly harmonize with the city's atmosphere.",
        ],
      },
      {
        heading: "Turning Dreams into Reality",
        paragraphs: [
          "In Weston, the backyard isn't just a space; it's an extension of your lifestyle. Our team at Precision Pavers takes pride in helping you transform your outdoor visions into realities. Whether you're dreaming of a luxurious pool area, an inviting deck, or an elegant driveway, we have the expertise and creativity to make it happen.",
        ],
      },
      {
        heading: "Choose Precision Pavers & Pool Design",
        paragraphs: [
          "Elevate your Weston living experience with Precision Pavers & Pool Design. With decades of experience and a commitment to excellence, we're here to turn your outdoor dreams into beautiful realities. Contact us today for a personalized consultation, and let us help you create the perfect outdoor haven.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "miramar",
    name: "Miramar",
    heroTitle:
      "Amplify Your Miramar, FL Space with Precision Pavers & Pool Design",
    hook: "Complete outdoor living services in Miramar",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/888d723c-32d7-45c1-870c-15c11b95f51a.jpg",
    citySpecificFact:
      "Serving Miramar including Miramar Lakes, Silver Shores, Sunset Lakes, New Hampton, and The Lakes of Miramar. Knowledgeable about Miramar building codes and dual-county (Broward/Miami-Dade) permitting.",
    sections: [
      {
        heading: "Miramar, Florida: Where Community Flourishes",
        paragraphs: [
          "Placed in the heart of Broward County, Miramar, Florida, is a city that embodies the perfect blend of community spirit and modern living. Known for its diverse neighborhoods, exceptional amenities, and a commitment to family-friendly living, Miramar offers an inviting and thriving environment.",
        ],
      },
      {
        heading: "Community at its Core",
        paragraphs: [
          "Miramar takes pride in its strong sense of community. From neighborhood gatherings to local events, this city fosters connections and bonds among its residents. It's a place where neighbors become friends, making it an ideal destination for families and individuals alike.",
        ],
      },
      {
        heading: "Green Spaces and Parks",
        paragraphs: [
          "With a wealth of parks and green spaces, Miramar encourages an active and healthy lifestyle. From picnics in the park to hiking trails, residents have ample opportunities to enjoy the great outdoors. The city's dedication to preserving natural spaces adds to its charm.",
        ],
      },
      {
        heading: "Precision Pavers & Pool Design: Crafting Community Spaces",
        paragraphs: [
          "In a city where community matters, Precision Pavers & Pool Design plays a vital role in enhancing communal outdoor spaces. We understand the importance of well-designed areas that bring people together and contribute to the vibrant community of Miramar. That's why we take tremendous pride in specializing in all things pool remodeling in Miramar, driveway paving and more!",
        ],
      },
      {
        heading: "Your Community Hub Awaits",
        paragraphs: [
          "Imagine a neighborhood park with a beautifully designed pool area, an inviting patio, and a playground for the kids. At Precision Pavers & Pool Design, we specialize in creating outdoor spaces that become the heart of your community, where friends and families gather and create lasting memories.",
        ],
      },
      {
        heading: "Elevate Your Miramar Lifestyle",
        paragraphs: [
          "Enrich your Miramar lifestyle with Precision Pavers & Pool Design. We appreciate the essence of community living in this vibrant city and are committed to designing outdoor spaces that promote togetherness. Contact us today for a personalized consultation and embark on a journey to create outdoor hubs that enrich the community spirit of Miramar.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "sunrise",
    name: "Sunrise",
    heroTitle:
      "Enhance Your Sunrise Florida Spaces with Precision Pavers & Pool Design",
    hook: "Pool remodeling and deck services in Sunrise",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/99d4ef10-d624-405e-9a56-fe80c03e55df.jpg",
    citySpecificFact:
      "Serving Sunrise including Sawgrass Mills area, Sunrise Lakes, Springtree, Welleby, Nob Hill, and Newland Acres. Familiar with Sunrise city regulations and proximity to Everglades wildlife district permitting.",
    sections: [
      {
        heading: "Sunrise, Florida: Where Every Sunrise Holds a Promise",
        paragraphs: [
          "Found in the heart of Broward County, Sunrise, Florida, is a city that lives up to its name. Here, each sunrise brings not only the promise of a new day but also the assurance of a vibrant, thriving community.",
        ],
      },
      {
        heading: "City of Opportunity",
        paragraphs: [
          "Sunrise has earned a reputation as a city of opportunity. Its strong local economy, with a thriving business district and job market, attracts people from all walks of life. It's a place where careers flourish and dreams come true.",
        ],
      },
      {
        heading: "Community and Culture",
        paragraphs: [
          "Beyond its economic vibrancy, Sunrise treasures its community and culture. This is a place where neighborhoods are close-knit, where families grow, and where diverse cultures blend harmoniously. The city's commitment to arts, sports, and community events fosters a strong sense of belonging.",
        ],
      },
      {
        heading:
          "Precision Pavers & Pool Design: Creating Outdoor Retreats in Sunrise",
        paragraphs: [
          "At Precision Pavers & Pool Design, we recognize the essence of Sunrise – a city that celebrates progress while valuing community bonds. Our mission is to enhance outdoor living spaces, reflecting the city's energy and the spirit of togetherness. We do this by providing elegant Sunrise swimming pool remodeling solutions, and many other paving services!",
        ],
      },
      {
        heading: "Crafting Dreams into Reality",
        paragraphs: [
          "Imagine a backyard pool, a deck where you can host gatherings under the warm Florida sun, a driveway that greets you with elegance every day. Precision Pavers & Pool Design specializes in turning these dreams into reality. We bring your vision to life with skill, precision, and an unwavering commitment to excellence.",
        ],
      },
      {
        heading: "Choose Precision Pavers & Pool Design",
        paragraphs: [
          "Elevate your Sunrise experience with Precision Pavers & Pool Design. We understand the unique character of this dynamic city and how to blend it seamlessly with your outdoor space. Contact us today for a personalized consultation and begin your journey towards an outdoor oasis that mirrors the spirit of Sunrise.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "miami",
    name: "Miami",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Miami, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Miami",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Miami. Family-owned. Tremron and Belgard materials. Free estimates. Serving all of Florida.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/57cc7d39-4870-4e62-abd3-cc6ad311d2cb.png",
    citySpecificFact:
      "Serving Miami neighborhoods including Brickell, Coral Gables, Coconut Grove, Wynwood, Miami Beach, Doral, Kendall, and Hialeah. Experienced with Miami-Dade County building codes, HOA requirements, and Florida statewide contractor regulations.",
    sections: [
      {
        heading: "Serving Miami & All of Florida",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Miami and communities across the state of Florida. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship backed by over 1,500 completed projects.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across Broward County — now available throughout Miami-Dade and all of Florida. Diamond Brite, Pebble Tec, Kool Deck, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Miami's Climate",
        paragraphs: [
          "Miami's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for South Florida's heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "davie",
    name: "Davie",
    heroTitle:
      "Upgrade Your Davie, FL Space with Precision Pavers & Pool Design",
    hook: "Driveway pavers and pool deck experts in Davie",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/c661c1dc-c91b-4ba6-9413-062121188c6c.jpg",
    citySpecificFact:
      "Serving Davie including Green Meadow, The Ranches, Birkdale, Rolling Hills, Sunshine Ranches, and Davie's western equestrian areas. Experienced with Davie's unique town charter, well and septic regulations, and rural property zoning.",
    sections: [
      {
        heading: "Davie, Florida: Bridging Nature and Community",
        paragraphs: [
          "Nestled within the heart of Broward County, Davie, Florida, is a unique blend of suburban charm and natural beauty. Known for its sprawling landscapes, equestrian culture, and a commitment to education, Davie is a city that offers a distinctive lifestyle.",
        ],
      },
      {
        heading: "Equestrian Capital",
        paragraphs: [
          'Davie proudly bears the title of "Equestrian Capital of the World." Horse lovers from all over the globe are drawn to this city for its numerous riding trails, equestrian parks, and ranches. Davie embodies the spirit of the Old West while embracing the modern world.',
        ],
      },
      {
        heading: "Education and Innovation",
        paragraphs: [
          "Davie is also home to prestigious educational institutions, including Nova Southeastern University. This focus on education and innovation has created a vibrant community of students and professionals, making it a hub for intellectual growth.",
        ],
      },
      {
        heading: "Precision Pavers & Pool Design: Crafting Natural Elegance",
        paragraphs: [
          "Amidst this natural beauty and intellectual vitality, Precision Pavers & Pool Design brings forth the concept of outdoor living as an art form. Our mission is to seamlessly blend the natural elegance of Davie with the outdoor spaces that we craft.",
        ],
      },
      {
        heading: "Outdoor Living Redefined",
        paragraphs: [
          "Imagine your backyard adorned with a shimmering pool, a patio that captures the essence of Florida's sunshine, or a driveway that's a testament to both form and function. At Precision Pavers & Pool Design, we specialize in transforming these visions into reality. We specialize in custom pool remodeling in Davie, pool deck resurfacing, driveway repair and restoration and more.",
        ],
      },
      {
        heading: "Choose Precision Pavers & Pool Design",
        paragraphs: [
          "Elevate your Davie experience with Precision Pavers & Pool Design. We understand the unique blend of nature and community that defines this city. Contact us today for a personalized consultation and embark on a journey to create an outdoor living space that complements the natural beauty and cultural richness of Davie.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "orlando",
    name: "Orlando",
    heroTitle:
      "Premium Pool Pavers, Deck Materials & Outdoor Products in Orlando, FL | Precision Pavers Showroom",
    hook: "Browse and purchase premium materials at our Orlando product showroom. Operations are strictly limited to product sales, material supply, and delivery.",
    seoDescription:
      "Visit our Orlando product showroom to browse and purchase premium pool pavers, travertine, tiles, and deck materials. Operations are strictly limited to product sales, material supply, and delivery.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/e1327c28-5c5f-40eb-b058-8470ff54f0ac.png",
    citySpecificFact:
      "Our Orlando location is a dedicated product showroom where homeowners and contractors can see and touch premium pavers, travertine, pool finishes, and deck materials. This location serves as a browse-and-purchase pickup point for your outdoor living materials. Operations are strictly limited to product sales, material supply, and delivery.",
    isProductOnly: true,
    showroomUrl: "https://orlando.precisionpaverspools.com/",
    sections: [
      {
        heading: "Premium Products in Orlando",
        paragraphs: [
          "Precision Pavers & Pool Design offers a premium product selection for Orlando and communities across the state of Florida. From Diamond Brite finishes to Tremron and Belgard pavers, we supply the best materials for your outdoor projects. Operations are strictly limited to product sales, material supply, and delivery.",
        ],
      },
      {
        heading: "Top-Tier Materials",
        paragraphs: [
          "We bring the same premium materials that have made us a trusted name across Florida. Discover our extensive collection of Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Built for Florida's Climate",
        paragraphs: [
          "Orlando's warm climate demands materials built to last. Our pool finishes, deck systems, and pavers are engineered for Florida's heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "Visit Our Showroom",
  },
  {
    slug: "tampa",
    name: "Tampa",
    heroTitle:
      "Premium Pool Pavers, Deck Materials & Outdoor Products in Tampa, FL | Precision Pavers Showroom",
    seoDescription:
      "Visit our Tampa product showroom to browse and purchase premium pool pavers, travertine, tiles, and deck materials. Operations are strictly limited to product sales, material supply, and delivery.",
    hook: "Browse and purchase premium materials at our Tampa product showroom. Operations are strictly limited to product sales, material supply, and delivery.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/eaf5a491-f323-4981-a5b2-e894b2c6a162.png",
    citySpecificFact:
      "Our Tampa location is a dedicated product showroom where homeowners and contractors can see and touch premium pavers, travertine, pool finishes, and deck materials. This location serves as a browse-and-purchase pickup point for your outdoor living materials. Operations are strictly limited to product sales, material supply, and delivery.",
    isProductOnly: true,
    showroomUrl: "https://tampa.precisionpaverspools.com/",
    sections: [
      {
        heading: "Premium Products in Tampa",
        paragraphs: [
          "Precision Pavers & Pool Design offers a premium product selection for Tampa and communities across the state of Florida. From Diamond Brite finishes to Tremron and Belgard pavers, we supply the best materials for your outdoor projects. Operations are strictly limited to product sales, material supply, and delivery.",
        ],
      },
      {
        heading: "Top-Tier Materials",
        paragraphs: [
          "We bring the same premium materials that have made us a trusted name across Florida. Discover our extensive collection of Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Built for Florida's Climate",
        paragraphs: [
          "Tampa's unique climate demands materials built to last. Our pool finishes, deck systems, and pavers are engineered for Florida's heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "Visit Our Showroom",
  },
  {
    slug: "coral-gables",
    name: "Coral Gables",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Coral Gables, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Coral Gables",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Coral Gables. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/7a41609f-7cfc-458d-b80e-edb6d2a6c860.webp",
    citySpecificFact:
      "Serving Coral Gables neighborhoods with expert pool remodeling, driveway pavers, and deck resurfacing. Experienced with Coral Gables building codes and HOA requirements.",
    sections: [
      {
        heading: "Serving Coral Gables",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Coral Gables and surrounding communities. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across South Florida. Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Florida's Climate",
        paragraphs: [
          "South Florida's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for the heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "brickell",
    name: "Brickell",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Brickell, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Brickell",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Brickell. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/e7b2bff8-ba8e-4212-8456-9b186e838597.webp",
    citySpecificFact:
      "Serving Brickell neighborhoods with expert pool remodeling, driveway pavers, and deck resurfacing.",
    sections: [
      {
        heading: "Serving Brickell",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Brickell and surrounding communities. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across South Florida. Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Florida's Climate",
        paragraphs: [
          "South Florida's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for the heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "coconut-grove",
    name: "Coconut Grove",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Coconut Grove, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Coconut Grove",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Coconut Grove. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/e71469d4-30df-4899-9bc8-011d87494378.webp",
    citySpecificFact:
      "Serving Coconut Grove neighborhoods with expert pool remodeling, driveway pavers, and deck resurfacing.",
    sections: [
      {
        heading: "Serving Coconut Grove",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Coconut Grove and surrounding communities. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across South Florida. Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Florida's Climate",
        paragraphs: [
          "South Florida's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for the heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "boca-raton",
    name: "Boca Raton",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Boca Raton, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Boca Raton",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Boca Raton. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/4afbb712-0a07-4bf8-b42b-dd23e2bacad2.webp",
    citySpecificFact:
      "Serving Boca Raton neighborhoods with expert pool remodeling, driveway pavers, and deck resurfacing. Experienced with Boca Raton building codes and HOA requirements.",
    sections: [
      {
        heading: "Serving Boca Raton",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Boca Raton and surrounding communities. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across South Florida. Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Florida's Climate",
        paragraphs: [
          "South Florida's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for the heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "delray-beach",
    name: "Delray Beach",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Delray Beach, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Delray Beach",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Delray Beach. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/f424bdb6-dcf1-4843-b690-ca97a72f2718.webp",
    citySpecificFact:
      "Serving Delray Beach neighborhoods with expert pool remodeling, driveway pavers, and deck resurfacing.",
    sections: [
      {
        heading: "Serving Delray Beach",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Delray Beach and surrounding communities. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across South Florida. Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Florida's Climate",
        paragraphs: [
          "South Florida's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for the heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "boynton-beach",
    name: "Boynton Beach",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Boynton Beach, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Boynton Beach",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Boynton Beach. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/13b804d2-b5e1-4bd5-823c-f3deccbadeae.webp",
    citySpecificFact:
      "Serving Boynton Beach neighborhoods with expert pool remodeling, driveway pavers, and deck resurfacing.",
    sections: [
      {
        heading: "Serving Boynton Beach",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Boynton Beach and surrounding communities. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across South Florida. Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Florida's Climate",
        paragraphs: [
          "South Florida's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for the heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "wellington",
    name: "Wellington",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Wellington, FL",
    hook: "Premium pool remodeling, pavers, and outdoor enhancements in Wellington",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Wellington. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/assets/5627cf6a-3a9d-43e5-9a95-b42af430fffd.webp",
    citySpecificFact:
      "Serving Wellington neighborhoods with expert pool remodeling, driveway pavers, and deck resurfacing. Experienced with Wellington's equestrian properties and estate homes.",
    sections: [
      {
        heading: "Serving Wellington",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Wellington and surrounding communities. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Premium Materials & Expert Craftsmanship",
        paragraphs: [
          "We bring the same premium materials and meticulous attention to detail that have made us the trusted choice across South Florida. Diamond Brite, Pebble Tec, Tremron, Belgard, and more.",
        ],
      },
      {
        heading: "Outdoor Living for Florida's Climate",
        paragraphs: [
          "South Florida's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for the heat, humidity, and heavy rainfall — ensuring your outdoor space stays beautiful year after year.",
        ],
      },
    ],
    closingCta: "",
  },
  {
    slug: "broward-county",
    name: "Broward County",
    type: "county",
    heroTitle: "Pool Remodeling, Pavers & Deck Services in Broward County, FL",
    hook: "Our home base. Full-service pool remodeling, pavers, and outdoor enhancements across all of Broward County.",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Broward County. Family-owned. Tremron and Belgard materials. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/46542dca-804d-446c-9e2f-54d466ce98b2.webp",
    citySpecificFact:
      "Serving all major cities in Broward County including Fort Lauderdale, Coral Springs, Pembroke Pines, Weston, Miramar, Sunrise, and Davie.",
    cities: [
      "Fort Lauderdale",
      "Coral Springs",
      "Pembroke Pines",
      "Weston",
      "Miramar",
      "Sunrise",
      "Davie",
    ],
    closingCta: "Get a Free Estimate",
    sections: [
      {
        heading: "Serving All of Broward County",
        paragraphs: [
          "Precision Pavers & Pool Design is proud to be Broward County's premier outdoor living contractor. From Fort Lauderdale to Weston, we bring decades of experience to every pool remodeling and paver installation project.",
        ],
      },
      {
        heading: "Expert Pool & Deck Remodeling",
        paragraphs: [
          "We specialize in transforming outdated pools and decks into luxurious outdoor retreats. Our team works with premium materials like Diamond Brite, Pebble Tec, and top-tier pavers to ensure lasting beauty and durability.",
        ],
      },
    ],
  },
  {
    slug: "miami-dade-county",
    name: "Miami-Dade County",
    type: "county",
    heroTitle:
      "Pool Remodeling, Pavers & Deck Services in Miami-Dade County, FL",
    hook: "Serving Miami and surrounding communities with our full suite of outdoor living services.",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Miami-Dade County. Family-owned. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/860177da-672b-40cd-bb58-1ec01e760279.webp",
    citySpecificFact:
      "Serving Miami-Dade County neighborhoods including Miami, Coral Gables, Brickell, and Coconut Grove. Experienced with Miami-Dade building codes and HOA requirements.",
    cities: ["Miami", "Coral Gables", "Brickell", "Coconut Grove"],
    closingCta: "Get a Free Estimate",
    sections: [
      {
        heading: "Serving Miami-Dade County",
        paragraphs: [
          "Precision Pavers & Pool Design proudly serves Miami-Dade County. From pool remodeling with Diamond Brite finishes to paver driveways using Tremron and Belgard, our team delivers expert craftsmanship.",
        ],
      },
      {
        heading: "Built for South Florida",
        paragraphs: [
          "Miami's tropical climate demands materials and designs built to last. Our pool resurfacing, deck systems, and paver installations are engineered for South Florida's heat, humidity, and heavy rainfall.",
        ],
      },
    ],
  },
  {
    slug: "palm-beach-county",
    name: "Palm Beach County",
    type: "county",
    heroTitle:
      "Pool Remodeling, Pavers & Deck Services in Palm Beach County, FL",
    hook: "Premium outdoor living services across Palm Beach County's finest communities.",
    seoDescription:
      "Premium pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements in Palm Beach County. Family-owned. Free estimates.",
    image:
      "https://vibe.filesafe.space/1779750798598342338/attachments/b900bafb-bed1-4baf-a1bf-9733672f51cb.webp",
    citySpecificFact:
      "Serving Palm Beach County including Boca Raton, Delray Beach, Boynton Beach, and Wellington.",
    cities: ["Boca Raton", "Delray Beach", "Boynton Beach", "Wellington"],
    closingCta: "Get a Free Estimate",
    sections: [
      {
        heading: "Serving Palm Beach County",
        paragraphs: [
          "Precision Pavers & Pool Design brings our trusted outdoor living expertise to Palm Beach County. We deliver premium pool remodeling, paver installations, and custom outdoor enhancements.",
        ],
      },
      {
        heading: "Luxury Outdoor Living",
        paragraphs: [
          "Elevate your Palm Beach County home with our high-end materials and expert craftsmanship. From custom pool finishes to elegant travertine decks, we create spaces designed for luxury and longevity.",
        ],
      },
    ],
  },
];
